import { runAfterBootstrap } from 'owa-delayed-initialization';
import { isFeatureEnabled } from 'owa-feature-flags';
import { createSpamStore, SpamScenarioId } from 'owa-spam-row-option';
import {
    getOptionsForFeature,
    AmpDeveloperOptions,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';

export { default as DynamicEmailOption } from './DynamicEmailOption';

runAfterBootstrap(() => {
    if (isFeatureEnabled('rp-amp')) {
        const options = getOptionsForFeature<AmpDeveloperOptions>(
            OwsOptionsFeatureType.AmpDeveloper
        );
        createSpamStore(
            SpamScenarioId.AllowedDynamicEmailSenders,
            options.allowedSender ? options.allowedSender : []
        );
    }
});
